import { Component, Input, OnInit, Output ,EventEmitter } from '@angular/core';

@Component({
  selector: 'app-switch-card',
  templateUrl: './switch-card.component.html',
  styleUrls: ['./switch-card.component.scss']
})
export class SwitchCardComponent implements OnInit {

  @Input() title : string;
  @Input()  value : boolean;
  @Input()  tooltip : string;
  @Input()  label : string;

  @Output() switchValueChange : EventEmitter<any> = new EventEmitter();

  constructor(){}

  ngOnInit(): void {}

  updateSwitchValues(event:boolean){
    this.switchValueChange.emit(event); 
  }

}
